
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 25 31.24"><path d="M3.13 31.24a3.065 3.065 0 0 1-1.477-.375A3.122 3.122 0 0 1 0 28.11V15.62c0-1.73 1.4-3.12 3.12-3.12 1.72 0 3.119 1.4 3.119 3.12v6.658l9.987-6.658L1.4 5.722A3.136 3.136 0 0 1 .53 1.39 3.136 3.136 0 0 1 4.86.519l18.75 12.5A3.124 3.124 0 0 1 25 15.62a3.124 3.124 0 0 1-1.389 2.602l-18.739 12.5a3.214 3.214 0 0 1-1.741.518z" style="stroke-width:.13953"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    